var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanderConceptIconPermit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 14.9524L8.9335 16.6667L12.6668 12.6667",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3332 20.25V20.496C19.3332 20.7954 19.2323 21.0862 19.0469 21.3214L14.7079 26.8254C14.4551 27.1462 14.0692 27.3333 13.6608 27.3333C13.6608 27.3333 13.6608 27.3333 13.6608 27.3333C13.6608 27.3333 13.6174 27.3333 13.5896 27.3333M19.3332 20.25V5.99998C19.3332 5.2636 18.7362 4.66665 17.9998 4.66665L15.3332 4.66666M19.3332 20.25H14.9229C14.1865 20.25 13.5896 20.8469 13.5896 21.5833C13.5896 21.5833 13.5896 21.5833 13.5896 21.5833C13.5896 21.5833 13.5896 25.0878 13.5896 27.3333M13.5896 27.3333C9.06351 27.3333 1.99984 27.3333 1.99984 27.3333C1.99984 27.3333 1.99984 27.3333 1.99984 27.3333C1.26346 27.3333 0.666504 26.7364 0.666504 26V5.99998C0.666504 5.2636 1.26346 4.66665 1.99984 4.66665L4.6665 4.66666M4.6665 4.66666V5.33333C4.6665 5.70152 4.96498 5.99999 5.33317 5.99999H14.6665C15.0347 5.99999 15.3332 5.70152 15.3332 5.33333V4.66666M4.6665 4.66666V3.99999C4.6665 3.6318 4.96498 3.33333 5.33317 3.33333H7.29561C7.31636 3.33333 7.33317 3.31651 7.33317 3.29577C7.33317 1.84375 8.51027 0.666654 9.96229 0.666656L10.0374 0.666657C11.4894 0.666659 12.6665 1.84375 12.6665 3.29577C12.6665 3.31651 12.6833 3.33333 12.7041 3.33333H14.6665C15.0347 3.33333 15.3332 3.6318 15.3332 3.99999V4.66666",
    stroke: "black",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanderConceptIconPermit);
export default __webpack_public_path__ + "static/media/lander-concept-icon-permit.e52f1c990f9e2911a34ed2c6bb2ef60e.svg";
export { ForwardRef as ReactComponent };